import React, { useEffect, useRef } from 'react';

import PropTypes from 'prop-types';
import { useEditor } from '@craftjs/core';

import TextFieldsIcon from '@mui/icons-material/TextFields';
import ExtensionIcon from '@mui/icons-material/Extension';
import DashboardIcon from '@mui/icons-material/Dashboard';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import TableRowsIcon from '@mui/icons-material/TableRows';
import SmartButtonIcon from '@mui/icons-material/SmartButton';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ImageIcon from '@mui/icons-material/Image';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import { Box, Tooltip } from '@mui/material';

export default function UserPrev({ element, name, iconName }) {
  const {
    connectors: { create },
  } = useEditor();

  const ref = useRef();

  useEffect(() => {
    if (ref?.current && create) {
      create(ref.current, element);
    }
  }, [create]);

  const renderIcon = (iconName) => {
    switch (iconName) {
      case 'textA':
        return <TextFieldsIcon />;
      case 'puzzle':
        return <ExtensionIcon />;
      case 'table':
        return <FormatListNumberedIcon />;
      case 'containerGrid':
        return <DashboardIcon />;
      case 'grid':
        return <DashboardIcon />;
      case 'containerRow':
        return <TableRowsIcon />;
      case 'containerColumn':
        return <TableRowsIcon sx={{ transform: 'rotate(90deg)' }} />;
      case 'pointer':
        return <SmartButtonIcon />;
      case 'imageIcon':
        return <ImageIcon />;
      case 'fixedTable':
        return <ViewModuleIcon />;
      case 'cards':
        return <DashboardCustomizeIcon />;
      default:
        return '';
    }
  };

  return (
    <Tooltip title={name}>
      <Box
        ref={ref}
        sx={{
          width: '30px',
          height: '30px',
          p: 1,
          mr: 2,
          backgroundColor: (theme) => theme?.palette?.background?.primary,
          color: (theme) => theme?.palette?.secondary?.dark,
          borderRadius: '3px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
          '&:hover': {
            opacity: 0.8,
          },
        }}
      >
        {renderIcon(iconName)}
      </Box>
    </Tooltip>
  );
}

UserPrev.propTypes = {
  element: PropTypes.node.isRequired,
  iconName: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};
